module.exports = __webpack_public_path__ + "static/content1-img-7ee5f794dbc7f14e5b66e5c24ff299a2.png";